<template>
  <button
    class="hero-cta"
    type="button"
    @click="$emit('click', $event)"
  >
    <span><slot /></span>
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      aria-hidden="true"
    >
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        d="M14 5l7 7m0 0l-7 7m7-7H3"
      />
    </svg>
  </button>
</template>

<script>
export default {
    name: 'CtaButton',
};
</script>

<style scoped>
.hero-cta {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  background: white;
  color: var(--unc-azul);
  font-family: var(--font-ui);
  font-size: 15px;
  font-weight: 600;
  padding: 14px 36px;
  border-radius: 100px;
  border: none;
  cursor: pointer;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.25);
  transition: transform 0.3s cubic-bezier(0.16, 1, 0.3, 1), box-shadow 0.3s cubic-bezier(0.16, 1, 0.3, 1);
  text-decoration: none;
  animation: fadeUp 0.8s ease 0.45s both;
  position: relative;
  overflow: hidden;
}

.hero-cta::before {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  width: 0;
  height: 0;
  border-radius: 50%;
  background: rgba(62, 182, 184, 0.2);
  transform: translate(-50%, -50%);
  transition: width 0.6s, height 0.6s;
  pointer-events: none;
}

.hero-cta:hover {
  transform: translateY(-4px);
  box-shadow: 0 16px 48px rgba(0, 56, 101, 0.2);
}

.hero-cta:hover::before {
  width: 420px;
  height: 420px;
}

.hero-cta svg {
  width: 18px;
  height: 18px;
  transition: transform 0.3s ease;
}

.hero-cta:hover svg {
  transform: translateX(4px);
}

@keyframes fadeUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@media (max-width: 600px) {
  .hero-cta {
    width: 100%;
    justify-content: center;
  }
}
</style>
